import { apiRoutes } from '../../api-routes';
import { httpClient } from '../../util';
import type { SavedPlace, SavedPlaceParams } from './types';

export const createUserPlaceFn = async (body: SavedPlaceParams) => {
  const method = body.code ? 'put' : 'post';
  const response = await httpClient[method]<SavedPlace>(
    apiRoutes.place.savedPlaces,
    body
  );
  return response.data;
};

export const deleteSavedPlaceFn = async (id: string) => {
  const response = await httpClient.delete<Response>(
    apiRoutes.place.savedPlaces + '/' + id
  );
  return response.data;
};
